import React, { Component } from "react";
import { Modal } from "antd";

import "styles/TableTop.scss";

export default class TableTopPopOver extends Component {
  state = {
    showUnitsModal: false,
  };

  // Units PopOver
  openUnits = () => this.setState({ showUnitsModal: true });
  closeUnits = () => this.setState({ showUnitsModal: false });

  render() {
    const { showUnitsModal } = this.state;
    return (
      <>
        <Modal open={showUnitsModal} onCancel={this.closeUnits} footer={null}>
          <h1 className="title">Unit</h1>
          <p>
            HSC subjects are usually worth 2 units; some are worth 1 unit. To
            complete the HSC, you must study at least 12 units in Year 11 and 10
            units in Year 12.
          </p>
        </Modal>
        <div className="table-top">
          <span className="label-units" onClick={this.openUnits}>
            Units
          </span>
        </div>
      </>
    );
  }
}
